import { Dispatch, SetStateAction, createContext, useContext } from "react";
import type { IOrder } from "../interfaces/IOrder";
import { IInStore } from "../interfaces/IProducts";
// import { ICartProduct } from "../interfaces/ICartProduct";

export type  CartContextType = {
    basketId?:string,  
    //basketType: BASKET_TYPE_CHOICES      // typ koszyka
    //products?: ICartProduct[],                                  // lista produktów w koszyku
    setProducts?: Dispatch<SetStateAction<IInStore[]>>,      // aktualizacja listy produktów (całej!)
   // 
    //userInfo?: any, // dane domyslne uzytkownika
    
    setNotification?: Dispatch<SetStateAction<String | undefined | JSX.Element>>,
    // first_name?:string, // to jest do wywalenia - próba
    // email?:string;      // to jest do wywalenia - próba

    isUserInfoRead?: boolean, // czy odczytano dane użytkownika z API     
    setIsUserInfoRead?: Dispatch<SetStateAction<boolean>>, 
    
    order?:IOrder,
    setOrder?:Dispatch<SetStateAction<IOrder>> 
    // updateFirstName?: Dispatch<SetStateAction<string>>
    activeStepId?:number,                                   // aktualny numer kroku wypełniania koszyka
    setActiveStepId?: Dispatch<SetStateAction<number>>,     // funkcja zmiany kroku
    
  }

export const CartContext = createContext<CartContextType>(
  {}
  );

export const useCartContext = () => useContext(CartContext)

// const CartContextProvider: React.FC<React.ReactNode> = ({ children }) => {
//     const [todos, setTodos] = React.useState<ITodo[]>([
//       {
//         id: 1,
//         title: 'post 1',
//         description: 'this is a description',
//         status: false,
//       },
//       {
//         id: 2,
//         title: 'post 2',
//         description: 'this is a description',
//         status: true,
//       },
//     ]);
// }

//export { CartContext};


// const CartContext = createContext({
//     cart: null,    
//   });
  
//   export { CartContext };
